import { Box, Grid, List, ListSubheader } from '@mui/material';
import { Theme } from '@mui/material/styles';
import * as React from 'react';
import { makeStyles } from 'tss-react/mui';
import { useCreateContactTag } from '../../../sic-lib/api/hooks/useContact';
import { ContactTag, SectionTag, buildCreateContactTag } from '../../../sic-lib/types/ContactTag';
import { IErrorFormValidation } from '../../../sic-lib/utils/formValidationHelpers';
import ButtonLoading from '../../Shared/ButtonLoading';
import TagListItem from './TagListItem';

interface Props {
    tagList: SectionTag;
    contactId: number;
    userTags: ContactTag[];
    compDispatch: React.Dispatch<
        Partial<{ searchTagName: string; formError: IErrorFormValidation | null }>
    >;
    tagName: string;
}

export default function MatchedTagsList({
    tagList,
    contactId,
    userTags,
    compDispatch,
    tagName,
}: Props) {
    const { classes } = useStyles();
    const {
        mutate: createTagMutation,
        isPending: isCreateLoading,
        isSuccess: isCreateSuccess,
    } = useCreateContactTag(contactId);

    const handleCreateTag = () => {
        if (userTags.find(itm => itm.tag === tagName)) {
            compDispatch({
                formError: {
                    fieldId: 1,
                    isFormError: true,
                    field: 'tag',
                    message: 'Tag already exist',
                },
            });
            return;
        } else {
            const tag = buildCreateContactTag({
                contactId: contactId,
                tag: tagName,
            });
            createTagMutation(tag, {
                onSuccess: () => {
                    compDispatch({ searchTagName: '' });
                },
            });
            compDispatch({ formError: null });
        }
    };
    return (
        <Grid container>
            {tagList.assigned.length === 0 && tagList.unassigned.length === 0 && (
                <Grid item justifyContent="center" width="100%">
                    <ButtonLoading
                        isLoading={isCreateLoading}
                        isSuccess={isCreateSuccess}
                        successLabel="Tag Created and Assigned"
                        onClick={handleCreateTag}
                    >
                        Create New Tag
                    </ButtonLoading>
                </Grid>
            )}
            <Box className={classes.menuList}>
                <List>
                    <ListSubheader>Assigned Tags</ListSubheader>
                    {tagList.assigned.map((aTag, index) => (
                        <TagListItem
                            data={aTag}
                            key={aTag.tagId}
                            style={{}}
                            contactId={contactId}
                        />
                    ))}
                </List>
                <List>
                    <ListSubheader>Unassigned Tags</ListSubheader>
                    {tagList.unassigned.map((aTag, index) => (
                        <TagListItem
                            data={aTag}
                            key={aTag.tagId}
                            style={{}}
                            contactId={contactId}
                        />
                    ))}
                </List>
            </Box>
        </Grid>
    );
}

const useStyles = makeStyles()((theme: Theme) => ({
    menuList: {
        overflowY: 'auto',
        display: 'flex',
        flexDirection: 'column',
        flexGrow: 1,
    },
}));
